// extracted by mini-css-extract-plugin
module.exports =  {"email-settings":"_2CLqmbAwmRKQ716QjldwK_"};